import React, { useState } from "react";
import Link from "next/link";
import InputGroup from "react-bootstrap/InputGroup";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import DynamicLink from "@components/Reusables/DynamicLink";
import Text from "components/Reusables/Text";
import { useRouter } from "next/router";
import { colors } from "utils/styles";

export default function CourseFilterButton(props = {}) {
	const { subNav, data = {}, withScroll = false, navIgnore = "" } = props;
	const { name, link, isExternal } = props.data;
	const [hovered, setHovered] = useState(false);

	const router = useRouter();

	//handle path with possible pagination
	//ex: path/page/[page]
	let path = router.asPath.split("/page")[0];
	path = path.split("?")[0];
	path = path.split("#")[0];
	path = path.replace(navIgnore, "");
	let navLink = link.replace(navIgnore, "");

	const isNestedPath = path.includes(navLink) && navLink.split("/").length > 2;
	const isPath = path === navLink || isNestedPath;

	return (
		<>
			{data.items?.length > 0 ? (
				<>
					<InputGroup size="sm" className="px- filterButtonsBar  w-auto  sub-nav-dropdown">
						<DropdownButton
							variant=""
							title={
								<>
									<span
										onMouseEnter={() => setHovered(true)}
										onMouseLeave={() => setHovered(false)}
										className="px-3 "
									>
										<span className="">{data?.name}</span>
									</span>
								</>
							}
							id={`${data?.name}-dropdown`}
						>
							{data.items.map((navItem) => {
								return (
									<Link key={navItem.link} href={`${navItem.link}`}>
										<Dropdown.Item href={`${navItem.link}`}>
											<Text color={colors.dark} size={16} marginBottom={0} text={navItem.name} />
										</Dropdown.Item>
									</Link>
								);
							})}
						</DropdownButton>
						<div className="filterBar with-adjustment ">
							{isPath && <div className="highlightBar "></div>}
						</div>
					</InputGroup>
				</>
			) : (
				<Link scroll={withScroll} href={link}
					className="col-auto clickable filterButtonsBar  "
					onMouseEnter={() => setHovered(true)}
					onMouseLeave={() => setHovered(false)}
					target={isExternal ? "_blank" : ""}
				>
						<span className="px-3">{name}</span>
						<div className="filterBar ">{isPath && <div className="highlightBar "></div>}</div>
				</Link>
			)}

			<style global jsx>{`
				#${data?.name}-dropdown.dropdown-toggle.btn {
					padding: 0 !important;
					display: flex;
					justify-content: end;
					align-items: center;
					border: none;
					height: fit-content;
				}

				.sub-nav-dropdown > .dropdown-toggle::after {
					margin-bottom: 0em;
					margin-left: -0.3em;
				}

				.sub-nav-dropdown .dropdown-menu.show {
					z-index: 10000;
				}
				a.filterButtonsBar,
				.filterButtonsBar,
				.sub-nav-dropdown .dropdown-toggle.btn {
					color: ${colors["darkBlue"]};
					font-weight: 600;
					font-size: 17px;
					border: none;
				}
				.sub-nav-dropdown {
					align-items: center;
					margin-left: 1px;
					margin-right: -1px;
					margin-top: 1px;
				}
			`}</style>
			<style jsx="true">{`
				a:hover {
					text-decoration: none;
				}
				.with-adjustment {
					margin-top: 0px !important;
					width: 100%;
				}

				.filterBar {
					margin-top: 0.5em;
					position: relative;
				}

				.filterBar:after {
					content: "";
					position: absolute;
					opacity: ${hovered ? 1 : 0.3};
					width: 100%;
					height: 3px;
					background: ${hovered ? colors["dark"] : colors["greyBlue"]};
				}

				.highlightBar {
					width: 100%;
					bottom: -3px;
					left: 0;
					position: absolute;
					height: 3px;
					background: ${colors["green"]};
				}
			`}</style>
		</>
	);
}
